/**
 * CategoryChips — family filter chips (2026-08-16 full-catalog directory;
 * extracted 2026-08-18, behavior unchanged): 'featured' (curated default) +
 * 'all apps' + the families + 'more apps' for the unclassified tail. Warm
 * palette on the active chip — never blue.
 */

import React from 'react';
import panelTheme from '../panelTheme';

export interface CategoryChipsProps {
  categories: string[];
  /** null = 'featured' default (when there is no search either). */
  selected: string | null;
  hasSearch: boolean;
  onSelect: (category: string) => void;
}

export const CategoryChips: React.FC<CategoryChipsProps> = ({
  categories,
  selected,
  hasSearch,
  onSelect,
}) => (
  <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1rem', flexWrap: 'wrap', alignItems: 'center' }}>
    {categories.map((cat) => {
      const active = cat === 'featured' ? !selected && !hasSearch : selected === cat;
      return (
        <button
          key={cat}
          onClick={() => onSelect(cat)}
          style={{
            padding: '0.35rem 0.7rem', borderRadius: '16px', fontSize: '0.82rem',
            border: active ? `1px solid ${panelTheme.gold}` : `1px solid ${panelTheme.grayBorder}`,
            background: active ? panelTheme.goldTint : '#fff',
            color: active ? panelTheme.goldInk : panelTheme.graySlate,
            cursor: 'pointer', fontWeight: active ? 600 : 400,
          }}
        >
          {cat}
        </button>
      );
    })}
  </div>
);

export default CategoryChips;
